// TODO: REMOVE AFTER LAUNCH - Temporary curtain revealing animation sequence
import React, { useState } from 'react';
import confetti from 'canvas-confetti';
import './CurtainIntro.css';

const CurtainIntro = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isUnmounted, setIsUnmounted] = useState(false);

  const handleOpen = () => {
    // If already opening, ignore
    if (isOpen) return;
    
    setIsOpen(true);
    triggerConfetti();

    // Ensure users start at the top of the app
    window.scrollTo(0, 0); 

    // After animation duration, completely unmount the curtain elements 
    // and remove zoom wrapper to ensure sticky Nav/Header continues working correctly
    setTimeout(() => {
      setIsUnmounted(true);
    }, 2500); 
  };

  const triggerConfetti = () => {
    const duration = 2500;
    const end = Date.now() + duration;

    (function frame() {
      // Pop from bottom left
      confetti({
        particleCount: 7,
        angle: 60,
        spread: 60,
        origin: { x: 0, y: 0.95 }, 
        colors: ['#e67e22', '#d35400', '#f1c40f', '#e74c3c', '#ffffff'],
        zIndex: 10000
      });
      // Pop from bottom right
      confetti({
        particleCount: 7,
        angle: 120,
        spread: 60,
        origin: { x: 1, y: 0.95 }, 
        colors: ['#e67e22', '#d35400', '#f1c40f', '#e74c3c', '#ffffff'],
        zIndex: 10000
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    }());
  };

  return (
    <>
      {/* 
        TODO: REMOVE AFTER LAUNCH 
        This wrapper applies the zoom-in scaling effect and is cleanly removed after 2.5s 
        to prevent CSS transform issues with fixed position headers.
      */}
      <div className={!isUnmounted ? `app-content-wrapper ${isOpen ? 'app-revealed' : ''}` : ''}>
        {children}
      </div>

      {!isUnmounted && (
        <div className={`curtain-container ${isOpen ? 'doors-open' : ''}`} onClick={handleOpen} style={{ cursor: 'pointer' }}>
          <div className="curtain-panel left-curtain"></div>
          <div className="curtain-panel right-curtain"></div>

          <div className={`curtain-center-content ${isOpen ? 'fade-out' : ''}`}>
            <h1>Welcome to Yoga Karega India</h1>
          </div>
        </div>
      )}
    </>
  );
};

export default CurtainIntro;
